import React from 'react'
import { StyleSheet, View } from 'react-native'
import { COMMON_STYLES } from '@dehaat/dds'
import RemovableFilterChip from 'app/components/reusable/RemovableFilterChip'

interface Props {
  appliedFilters?: string[]
  onClearFilter?: (filter?: string) => void
}

const FilterButton = ({ appliedFilters = [], onClearFilter }: Props) => {
  return (
    <View style={[COMMON_STYLES.row, styles.container]}>
      {appliedFilters.map(label => (
        <RemovableFilterChip
          key={label}
          label={label}
          onRemove={() => onClearFilter?.(label)}
        />
      ))}
    </View>
  )
}

export default FilterButton

const styles = StyleSheet.create({
  container: {
    flexWrap: 'wrap',
    gap: 6,
  },
})
